export {latestNewsQuery} from "./latestArticles.groq";
export {newsBySlugQuery} from "./newsPageBySlug.groq";
export {newsPathsQuery} from "./newsSlugs.groq";
export {newsTypesQuery} from "./newsTypes.groq";
export {newsQuery} from "./news.groq";
